
import { useCrawler as useRefactoredCrawler } from './crawler';

export function useCrawler() {
  const crawler = useRefactoredCrawler();
  
  return {
    ...crawler
  };
}
